import _ from "lodash";
import React, { useContext, useEffect } from "react";
import { withRouter, Switch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import CONSTANTS from "./../common/constants";

import Home from './Home/Home';
import Menu from "./Menu/Menu";
import Vehicles from './Vehicles/Vehicles';
import { OidcContext } from "./OidcContext";
import Forbidden from './Forbidden/Forbidden';
import { handle } from "../common/responseHandler";
import Customers from './Customers/List/Customers';
import Actions from "../store/actions/cultureActions";
import AuthenticatedRoute from "./AuthenticatedRoute/AuthenticatedRoute";

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(OidcContext);

  const version = useSelector((state) =>
    _.get(state, `environment.version`, `NO VERSION FOUND`)
  );

  useEffect(() => {
    if (isAuthenticated()) {
      dispatch(Actions.getAllLanguages()).catch(handle);
    }
  }, [dispatch, isAuthenticated]);

  return (
    <>
      <Menu />
      <div id="pagecontent">
        <section className="maincontent">
          <div className="container">
            <Switch>
              <AuthenticatedRoute
                path={CONSTANTS.ROUTE.ROOT}
                requiresAuthorization
                exact
                component={Home}
              />
              <AuthenticatedRoute
                path={CONSTANTS.ROUTE.CUSTOMERS}
                requiresAuthorization
                component={Customers}
              />
              <AuthenticatedRoute
                path={CONSTANTS.ROUTE.VEHICLES}
                requiresAuthorization
                component={Vehicles}
              />
              <AuthenticatedRoute
                path={CONSTANTS.ROUTE.FORBIDDEN}
                component={Forbidden}
              />
            </Switch>
          </div>
        </section>
      </div>
      <footer>
        <em>Version: {version}</em>
      </footer>
    </>
  );
}

export default withRouter(App);
